import produce from 'immer';
import { handleActions } from 'redux-actions';
import actions from './actions';
import {
  CS_QNA_LIST_FILTER_OPTION_MODEL,
  CS_QNA_LIST_SORT_OPTION_MODEL,
  CS_QNA_DETAIL_PRODUCT_INFO_MODEL,
  CS_QMA_DETAIL_QNA_INFO_MODEL,
} from './models';
import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../../app/models';
import { updateStoreWithPath } from '../../../../lib/common';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  상품 문의 리스트
   */
  csQnaList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  필터 옵션
     */
    filterOption: CS_QNA_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션 리스트
     */
    sortOption: CS_QNA_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  /**
   *  상품 문의 상세
   */
  csQnaDetail: {
    /**
     *  상품 정보
     */
    productInfo: CS_QNA_DETAIL_PRODUCT_INFO_MODEL,

    /**
     *  문의 정보
     */
    qnaInfo: CS_QMA_DETAIL_QNA_INFO_MODEL,
  },

  /**
   *  상품 문의 질문 모달
   */
  csQnaQuestionModal: {
    isOpen: false,
    data: {},
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [상품 문의] 상품 문의 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  [상품 문의 리스트] 상품 문의 리스트 요청하기
     */
    [actions.GET_QNA_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상품 문의 리스트
         */
        draft.csQnaList = action.payload.csQnaList;
      });
    },

    /**
     *  [상품 문의 상세] 상품 문의 상세 요청하기
     */
    [actions.GET_QNA_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  문의 정보
         */
        draft.csQnaDetail.qnaInfo = action.payload.qnaInfo;
        /**
         *  상품 정보
         */
        draft.csQnaDetail.productInfo = action.payload.productInfo;
      });
    },

    /**
     *  [상품 문의 상세] 유저의 다른 문의 내역 요청하기
     */
    [actions.GET_USERS_OTHER_QNA_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  유저 정보
         */
        draft.csQnaDetail.qnaInfo.usersOtherQna = action.payload.qnaInfo.usersOtherQna;
      });
    },

    /**
     *  [상품 문의 상세] 상품 문의 답변하기
     */
    [actions.REPLY_QNA_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  답변까지 걸린 시간
         */
        draft.csQnaDetail.qnaInfo.timeReply = action.payload.timeReply;
        /**
         *  답변 일자
         */
        draft.csQnaDetail.qnaInfo.answerDate = action.payload.answerDate;
        /**
         *  답변까지 걸린 시간
         */
        draft.csQnaDetail.qnaInfo.replyAuthor = action.payload.replyAuthor;
      });
    },

    /**
     *  [상품 문의 상세] 질문 내용 모달 토글
     */
    [actions.TOGGLE_MODAL]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath([action.payload.name, 'isOpen'], action.payload.isOpen, draft);
        updateStoreWithPath([action.payload.name, 'data'], action.payload.data, draft);
      });
    },
  },
  initialState,
);
